import { defaultEmptyValueOption } from '@/_shared';

import { type AddressFormSchema } from './address-form-schema';

import { defaultCountry } from '../../../../_schemas/countries';

export const defaultAddressValues: Readonly<AddressFormSchema> = {
  is_valid_postal_code: false,
  id: -1,
  address1: '',
  address2: '',
  postal_code: '',
  city: defaultEmptyValueOption(),
  state: null,
  country: defaultCountry,
  region: '',
  validation_action: null,
  validation_decision: 'pending',
} as const;
